/* ===================================
   THEADORE — Global JavaScript
   =================================== */

(function () {
  'use strict';

  const cartDrawer      = document.getElementById('cart-drawer');
  const cartToggle      = document.getElementById('cart-toggle');
  const cartClose       = document.getElementById('cart-close');
  const overlay         = document.getElementById('overlay');
  const cartCount       = document.getElementById('cart-count');

  // ── Cart open / close ───────────────────────────────
  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  function closeAll() { closeCart(); closeMobileNav(); }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose)  cartClose.addEventListener('click', closeCart);
  if (overlay)    overlay.addEventListener('click', closeAll);

  // ── Mobile Nav ──────────────────────────────────────
  const mobileNav  = document.getElementById('mobile-nav');
  const menuToggle = document.getElementById('menu-toggle');
  const menuClose  = document.getElementById('menu-close');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('open');
    mobileNav.setAttribute('aria-hidden', 'false');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (!cartDrawer || !cartDrawer.classList.contains('open')) {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
  }

  if (menuToggle) menuToggle.addEventListener('click', openMobileNav);
  if (menuClose)  menuClose.addEventListener('click', closeMobileNav);

  // ── Search ──────────────────────────────────────────
  const searchToggle = document.getElementById('search-toggle');
  const searchBar    = document.getElementById('search-bar');
  const searchInput  = document.getElementById('search-input');

  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      const isOpen = searchBar.classList.toggle('open');
      if (isOpen) setTimeout(() => searchInput && searchInput.focus(), 100);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (searchBar) searchBar.classList.remove('open');
      closeAll();
    }
  });

  // ── Sticky Header ───────────────────────────────────
  const siteHeader = document.getElementById('site-header');
  window.addEventListener('scroll', function () {
    if (siteHeader) siteHeader.classList.toggle('scrolled', window.scrollY > 10);
  }, { passive: true });

  // ── Cart refresh via Shopify Sections API ───────────
  async function refreshCartDrawer() {
    if (!cartDrawer) return;
    try {
      const res  = await fetch('/?sections=cart-drawer');
      const data = await res.json();
      const html = data['cart-drawer'];
      if (!html) return;

      const temp = document.createElement('div');
      temp.innerHTML = html;
      const newDrawer = temp.querySelector('#cart-drawer');
      if (!newDrawer) return;

      // Swap dynamic regions, preserve open state
      const swap = function (selector) {
        const cur = cartDrawer.querySelector(selector);
        const nxt = newDrawer.querySelector(selector);
        if (cur && nxt) cur.outerHTML = nxt.outerHTML;
        else if (nxt && !cur) cartDrawer.appendChild(nxt.cloneNode(true));
      };

      swap('#cart-items');
      swap('.cart-drawer__shipping-progress');
      swap('#cart-drawer-count');

      // Show/hide footer based on item count (footer is always in DOM now)
      const newCountEl = newDrawer.querySelector('#cart-drawer-count');
      const footerEl = cartDrawer.querySelector('.cart-drawer__footer');
      if (footerEl) {
        const count = parseInt(newCountEl?.textContent?.replace(/\D/g, '') || '0', 10);
        footerEl.style.display = count > 0 ? '' : 'none';
      }

      // Sync subtotal
      const newSubtotal = newDrawer.querySelector('#cart-subtotal');
      const curSubtotal = cartDrawer.querySelector('#cart-subtotal');
      if (newSubtotal && curSubtotal) curSubtotal.textContent = newSubtotal.textContent;

      // Sync header badge from drawer count (avoids extra /cart.js fetch)

      if (newCountEl && cartCount) {
        const count = parseInt(newCountEl.textContent, 10) || 0;
        cartCount.textContent = count;
        cartCount.dataset.count = count;
        cartCount.style.display = count > 0 ? 'flex' : 'none';
      }

      // Re-bind close button (it got replaced)
      const newClose = cartDrawer.querySelector('#cart-close');
      if (newClose) newClose.addEventListener('click', closeCart);
    } catch (e) {
      console.warn('Cart refresh failed:', e);
    }
  }

  async function updateCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const data = await res.json();
      const count = data.item_count;
      if (cartCount) {
        cartCount.textContent  = count;
        cartCount.dataset.count = count;
        cartCount.style.display = count > 0 ? 'flex' : 'none';
      }
    } catch (e) {}
  }

  // ── Add to cart (AJAX intercept) ────────────────────
  document.addEventListener('submit', async function (e) {
    const form = e.target;
    if (!form.action || !form.action.includes('/cart/add')) return;
    e.preventDefault();
    // The sticky bar dispatches submit directly, which skips `required` checks
    if (!form.reportValidity()) return;

    const btn = form.querySelector('[type="submit"]');
    const orig = btn ? btn.innerHTML : '';
    if (btn) { btn.innerHTML = 'Adding…'; btn.disabled = true; }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form)
      });

      if (!res.ok) throw new Error('add failed');

      await refreshCartDrawer();
      openCart();

      if (btn) { btn.innerHTML = '✓ Added'; }
      setTimeout(() => {
        if (btn) { btn.innerHTML = orig; btn.disabled = false; }
      }, 1500);
    } catch (err) {
      console.error(err);
      if (btn) { btn.innerHTML = 'Error — try again'; btn.disabled = false; }
    }
  });

  // ── Configurator bundle integrity ───────────────────
  // The diamond configurator adds 3 lines (ring + diamond add-on + gold add-on)
  // sharing one `_bundle` id. These helpers keep them locked together so a
  // customer can never remove the add-ons and check out with a zero-value ring.

  // Change a line's qty and cascade to every line sharing its `_bundle`.
  // Accepts a line-item KEY (robust to reordering). qty 0 = remove.
  async function cartChangeCascade(key, qty) {
    const cart  = await (await fetch('/cart.js')).json();
    const items = cart.items || [];
    const target = items.find(it => it.key === key);
    const updates = {};
    const bundle = target && target.properties && target.properties._bundle;
    if (bundle) {
      items.forEach(it => {
        if (it.properties && it.properties._bundle === bundle) updates[it.key] = qty;
      });
    } else {
      updates[key] = qty;
    }
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
  }
  window.cartChangeCascade = cartChangeCascade;

  // Repair the cart: drop orphaned add-ons and re-sync add-on qty to the ring.
  // Returns true if it changed anything. Safe to call on every page load and
  // right before checkout.
  async function cartGuardian() {
    try {
      const cart  = await (await fetch('/cart.js')).json();
      const items = cart.items || [];
      const groups = {};
      items.forEach(it => {
        const b = it.properties && it.properties._bundle;
        if (b) (groups[b] = groups[b] || []).push(it);
      });
      const updates = {};
      let changed = false;
      Object.keys(groups).forEach(b => {
        const g = groups[b];
        const parent = g.find(x => !(x.properties && x.properties._type));
        if (!parent) {                       // ring gone -> drop stranded add-ons
          g.forEach(x => { updates[x.key] = 0; changed = true; });
          return;
        }
        g.forEach(x => {                     // add-on qty must match the ring
          if (x.quantity !== parent.quantity) { updates[x.key] = parent.quantity; changed = true; }
        });
      });
      // add-on that lost its bundle id entirely can't be tied to a ring -> drop
      items.forEach(it => {
        const t = it.properties && it.properties._type;
        const b = it.properties && it.properties._bundle;
        if (t && !b) { updates[it.key] = 0; changed = true; }
      });
      if (changed) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
      }
      return changed;
    } catch (e) {
      console.warn('cartGuardian failed:', e);
      return false;
    }
  }
  window.cartGuardian = cartGuardian;

  // ── Cart qty / remove (drawer) ──────────────────────
  document.addEventListener('click', async function (e) {
    const qtyBtn    = e.target.closest('.qty-btn');
    const removeBtn = e.target.closest('.cart-item__remove');
    if (!qtyBtn && !removeBtn) return;

    const btn      = qtyBtn || removeBtn;
    // Only drawer items carry data-line; the /cart page has its own handler.
    if (btn.dataset.line === undefined) return;

    const delta    = parseInt(btn.dataset.delta || '0', 10);
    const cartItem = btn.closest('.cart-item');
    const key      = cartItem ? cartItem.dataset.key : null;
    const qtyEl    = cartItem ? cartItem.querySelector('.cart-item__qty span') : null;
    const current  = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    const newQty   = removeBtn ? 0 : Math.max(0, current + delta);
    if (!key) return;

    try {
      await cartChangeCascade(key, newQty);   // cascades to the whole bundle
      await refreshCartDrawer();
    } catch (err) {
      console.error('Cart update failed:', err);
    }
  });

  // ── Phase 2: single clean line via Draft Order checkout ──
  // Sends the cart to our backend, which collapses each configurator bundle into
  // ONE priced line (price recomputed server-side from real variant prices) and
  // returns a Shopify invoice/checkout URL. Falls back to native /checkout if the
  // service is unreachable, so checkout never fully breaks.
  const REVERA_CHECKOUT_API = 'https://adforge.jayperclick.com/rv-checkout';

  async function reveraDraftCheckout(fallbackUrl) {
    const fb = fallbackUrl || '/checkout';
    try {
      const cart = await (await fetch('/cart.js')).json();
      const items = (cart.items || []).map(function (it) {
        return { variant_id: it.variant_id, quantity: it.quantity, properties: it.properties || {} };
      });
      if (!items.length) { window.location.href = fb; return; }
      // Only old configurator bundles (ring + add-on lines) need collapsing; real priced
      // variants (rebuilt gold, silver) go straight to native checkout.
      if (!items.some(function (it) { return it.properties && it.properties._bundle; })) { window.location.href = fb; return; }
      const res = await fetch(REVERA_CHECKOUT_API + '/create-draft', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (res.ok) {
        const data = await res.json();
        if (data.invoice_url) { window.location.href = data.invoice_url; return; }
      }
      window.location.href = fb;              // any non-OK -> native checkout
    } catch (e) {
      window.location.href = fb;             // network/backend down -> native checkout
    }
  }
  window.reveraDraftCheckout = reveraDraftCheckout;

  // ── Guard + route drawer checkout ──
  document.addEventListener('click', async function (e) {
    const link = e.target.closest('.cart-drawer__checkout');
    if (!link) return;
    e.preventDefault();
    const changed = await cartGuardian();
    if (changed) {
      await refreshCartDrawer();              // show the corrected cart, don't proceed
      return;
    }
    await reveraDraftCheckout(link.getAttribute('href') || '/checkout');
  });

  // ── Wishlist (localStorage) ─────────────────────────
  let wishlist = JSON.parse(localStorage.getItem('theadore_wishlist') || '[]');

  function saveWishlist() {
    localStorage.setItem('theadore_wishlist', JSON.stringify(wishlist));
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.product-card__wishlist');
    if (!btn) return;
    const handle = btn.dataset.handle;
    if (!handle) return;
    const idx = wishlist.indexOf(handle);
    if (idx === -1) {
      wishlist.push(handle);
      btn.classList.add('active');
      btn.setAttribute('aria-label', 'Remove from wishlist');
    } else {
      wishlist.splice(idx, 1);
      btn.classList.remove('active');
      btn.setAttribute('aria-label', 'Add to wishlist');
    }
    saveWishlist();
  });

  document.querySelectorAll('.product-card__wishlist').forEach(btn => {
    if (btn.dataset.handle && wishlist.includes(btn.dataset.handle)) {
      btn.classList.add('active');
    }
  });

  // ── Init ────────────────────────────────────────────
  updateCartCount();
  // Self-heal any orphaned/desynced configurator bundle from a prior session.
  cartGuardian().then(function (changed) { if (changed) refreshCartDrawer(); });

  // Expose cart helpers globally for other scripts (e.g. rv-product-options)
  window.refreshCart = async function() {
    await refreshCartDrawer();
    openCart();
  };

})();
